import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    // eslint-disable-next-line no-console
    console.log(`Error: ${error}`);
    // eslint-disable-next-line no-console
    console.log('Component stack trace: ', info);
  }

  render() {
    if (this.state.hasError) {
      // render any fallback UI
      return null;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./containers/error-boundary/index.js